import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spinner } from '../ui/Spinner';

export function RotaProtegida({ children, exigirCadastroCompleto = false }: { children: ReactNode; exigirCadastroCompleto?: boolean }) {
  const { session, cidadao, loading, cadastroCompleto } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner tamanho="lg" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ de: location.pathname }} replace />;
  }

  // Logado mas ainda sem perfil em `cidadaos` (ex.: 1º acesso via Google):
  // força completar o cadastro, onde a linha é criada com o CPF.
  if (!cidadao && location.pathname !== '/completar-cadastro') {
    return <Navigate to="/completar-cadastro" replace />;
  }

  if (exigirCadastroCompleto && cidadao && !cadastroCompleto) {
    return <Navigate to="/completar-cadastro" replace />;
  }

  return <>{children}</>;
}
